import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://high.innohed.com/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (username: string, password: string) =>
    api.post('/v1/auth/login', { username, password }),
};

export const accountAPI = {
  getAll: () => api.get('/v1/accounts'),
  getABook: () => api.get('/v1/accounts/a-book'),
  getOne: (accountId: string) => api.get(`/v1/accounts/${accountId}`),
  getHistory: (accountId: string) => api.get(`/v1/accounts/${accountId}/history`),
  returnToBBook: (accountId: string) => api.post(`/v1/accounts/${accountId}/return-to-b`),
  health: () => api.get('/v1/accounts/health'),
};

export default api;
